import { format } from 'date-fns';
import _ from 'lodash';
import * as React from 'react';
import { PatientBadge } from '../badge';
import * as S from './patient-search-result.styles';

export interface IPatientSearchResultProps {
    id: string;
    externalId?: string;
    first: string;
    last: string;
    suffix: string;
    sex: string;
    dob: string;
    nickname: string;
    children?: React.ReactNode;
}

export class PatientSearchResult extends React.PureComponent<IPatientSearchResultProps> {
    public render(): React.ReactNode {
        const { id, externalId, first, last, suffix, sex, dob, children, nickname } = this.props;
        const gender = _.toUpper(sex[0]);
        return (
            <S.Result>
                <S.Patient>
                    {id && (
                        <S.PatientTop>
                            <b>Patient</b>
                            <S.Spacer />
                            {externalId ? <span><b>ID</b>{externalId}</span> : <></>}
                            <b>DOB</b>
                            <span>{format(dob, 'yyyy/MM/dd')}</span>
                            <b>{gender}</b>
                        </S.PatientTop>
                    )}
                    <S.PatientBottom>
                        <S.PatientName>
                            {first} {last} {nickname ? '(' + nickname + ')' : ''}
                        </S.PatientName>
                        <S.Spacer />
                        <PatientBadge
                            id={id}
                            first={first}
                            last={last}
                            suffix={suffix}
                            externalId={externalId}
                            path={`/patients/${id}/statement`}
                            tooltip="View Patient Statement"
                        />
                    </S.PatientBottom>
                </S.Patient>
                {!!children && (
                    <S.ClaimTable>
                        <tbody>{children}</tbody>
                    </S.ClaimTable>
                )}
            </S.Result>
        );
    }
}
